import { render } from "./FormButton.vue?vue&type=template&id=79004a34&scoped=true"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"

import "./FormButton.vue?vue&type=style&index=0&id=79004a34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79004a34"

export default script